import { Injectable, signal } from '@angular/core';
import { LOADER_HIDE_DEBOUNCE } from '@constants';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private counter = 0;
  private hideTimer: ReturnType<typeof setTimeout> | undefined;
  readonly visible = signal(false);
  readonly message = signal('');

  show(source?: string): void {
    const cancelledTimer = this.hideTimer !== undefined;
    if (cancelledTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }
    this.counter++;
    console.warn(`[LOADER] show(${source ?? 'interceptor'}) → counter=${this.counter}, cancelledTimer=${cancelledTimer}`);
    if (this.counter === 1) {
      this.visible.set(true);
    }
  }

  hide(source?: string): void {
    this.counter--;
    console.warn(`[LOADER] hide(${source ?? 'interceptor'}) → counter=${this.counter}`);
    if (this.counter <= 0) {
      this.counter = 0;
      this.hideTimer = setTimeout(() => {
        console.warn(`[LOADER] debounce fired → visible=false`);
        this.visible.set(false);
        this.message.set('');
        this.hideTimer = undefined;
      }, LOADER_HIDE_DEBOUNCE);
    }
  }

  setMessage(msg: string): void {
    this.message.set(msg);
  }
}
